const env = require('env')
const { host, plugin, name, wxConf } = env

// for (let h in host) {
//   host[h] = location.protocol + host[h]
// }
// 如果是本地开发，使用未压缩的插件
if (process.env.NODE_ENV === 'development') {
  for (let key in plugin) {
    plugin[key] = plugin[key].replace('.min', '')
  }
}
export {
  host,
  plugin,
  name,
  wxConf
}
export default env
